import { type ComponentProps, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

export type BreadcrumbsItemProps = Omit<ComponentProps<'div'>, 'prefix'> & {
  prefix?: ReactNode;
  suffix?: ReactNode;
};

export const BreadcrumbsItem = memo(({ children, className, prefix, suffix, ...restOfProps }: BreadcrumbsItemProps) => {
  return (
    <div
      className={cn('flex min-w-0 items-center gap-1 px-1 font-medium text-grey-9 ui2:text-grey-11', className)}
      data-testid="BREADCRUMBS_ITEM"
      {...restOfProps}
    >
      {!!prefix && <div className="shrink-0">{prefix}</div>}

      <div className="truncate">{children}</div>

      {!!suffix && <div className="shrink-0">{suffix}</div>}
    </div>
  );
});

BreadcrumbsItem.displayName = 'BreadcrumbsItem';
